module.exports = window.top.seamlessLogger;